import { createRouter, createWebHistory } from 'vue-router';
import { authRoutes } from '@/router/authRoutes';
import { serviceRoutes } from '@/router/serviceRoutes';
import { publicRoutes } from '@/router/publicRoutes';
import { crmRoutes } from '@/router/crmRoutes';
import { AuthMiddleware } from '@/router/Middleware/AuthMiddleware';
import { planBatchRoutes } from '@/router/planBatchRoutes';

const routes = [
  {
    path: '/access_denied',
    name: 'access_denied',
    component: () => import('../Pages/Service/Access/Denied.vue'),
    meta: { name: 'Нет доступа' },
  },
  ...authRoutes,
  ...serviceRoutes,
  ...publicRoutes,
  ...crmRoutes,
  ...planBatchRoutes,

  {
    path: '/:pathMatch(.*)*',
    redirect: '/crm/plans',
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(AuthMiddleware);

export { router, routes };
